import React from "react";

const AboutSection =()=>{

    return(
        <section className="about-section">
            <div className="container flex-column center about-layout">
                <div className="title-box center-text">
                    <h1 className="main-text">About Me</h1>
                </div>
                <div className="wrapper">
                <p>I'm James, a passionate, Web Developer, specializing in React.js for frontend designs and Django for backend data storage for most projects. My expertise is creating tools that automate and solve various tasks and creating online enviroments where users can interact with one another.</p>
            
                </div>
           </div>
        </section>
    )
}

export default AboutSection;